import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/personal_/')({
	loader: async () => {
		// Redirect to overview by default
		throw redirect({
			to: '/personal/overview',
		});
	},
	component: PersonalIndexPage,
});

function PersonalIndexPage() {
	// This should never render due to redirect, but serves as fallback
	return (
		<div className="p-4 text-center">
			Redirecting to overview...
		</div>
	);
}
